import React from "react";
import { Box } from "@mui/material";
import HeroPanel1 from "../components/HeroPanel1";
import HeroPanel2 from "../components/HeroPanel2";
import HeroPanel3 from "../components/HeroChannel3";
import HeroPanel4 from "../components/HeroPanel4";
import Footer from "../components/Footer";

function ChannelManagerPage() {
  return (
    <Box
      sx={{
        height: "100vh",
        overflowY: "scroll",
        scrollSnapType: "y mandatory",
        scrollBehavior: "smooth",
      }}
    >
      {/* Sección 1 - HeroChannel1 */}
      <Box
        sx={{
          scrollSnapAlign: "start",
          height: "100vh",
          minHeight: "100vh",
          overflow: "hidden", // 👈 Evita que se solape
          position: "relative",
          zIndex: 1, // 👈 Asegura la superposición correcta
        }}
      >
        <HeroPanel1 />
      </Box>
      {/* Sección 3 - HeroChannel3 */}
      <Box
        sx={{
          scrollSnapAlign: "start",
          height: {
            xs: "auto",
            sm: "auto",
            md: "100vh",
            lg: "100vh",
            xl: "100vh",
          },
          minHeight: "100vh",
          overflow: "hidden",
          position: "relative",
          zIndex: 1,
          mt: 0, // 👈 Evita saltos
        }}
      >
        <HeroPanel4 />
      </Box>
      {/* Sección 2 - HeroChannel2 */}
      <Box
        sx={{
          scrollSnapAlign: "start",
          height: {
            xs: "auto",
            sm: "auto",
            md: "100vh",
            lg: "100vh",
            xl: "100vh",
          },
          minHeight: "100vh",
          position: "relative",
          zIndex: 1,
          mt: 0, // 👈 Evita saltos
        }}
      >
        <HeroPanel2 />
      </Box>

      {/* Sección 3 - HeroChannel3 */}
      <Box
        sx={{
          scrollSnapAlign: "start",
          height: {
            xs: "auto",
            sm: "auto",
            md: "100vh",
            lg: "100vh",
            xl: "100vh",
          },
          minHeight: "100vh",
          overflow: "hidden",
          position: "relative",
          zIndex: 1,
          mt: 0, // 👈 Evita saltos
        }}
      >
        <HeroPanel3 />
      </Box>

      <Box
        sx={{
          scrollSnapAlign: "start",
        }}
      >
        <Footer />
      </Box>
    </Box>
  );
}

export default ChannelManagerPage;
